/**
 * Break-glass: the thin track that fills over 30 seconds while we poll carriers
 * for quotes — a replica of the legacy Cargo ProgressBar.
 *
 * The fill is a width transition started on mount, so the width is a runtime
 * value on a transitioning element; the 5px track height and the 500px cap are
 * off the layout scale. None of that is expressible as component props, and the
 * bottom gutter comes along because the caller renders the bar conditionally and
 * has nowhere to hang a gap.
 */

import { useEffect, useState } from "react";

export function BookShipmentQuoteLoadingBar() {
  const [started, setStarted] = useState(false);

  useEffect(() => {
    const raf = requestAnimationFrame(() => setStarted(true));
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <div className="mb-8 h-[5px] w-full max-w-[500px] bg-light-gray">
      <div
        className={`h-full bg-brand transition-[width] duration-[30s] ease-[ease] ${
          started ? "w-full" : "w-0"
        }`}
      />
    </div>
  );
}
